export default __webpack_public_path__ + "static/media/careernav01.c201a4ce.jpg";